module.exports = __webpack_public_path__ + "img/clear-filter.17c1568b.png";